<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { HFarmCorporateNavbarMixin } from "../../modules/hfarm_corporate_mixins_module";

export default {
  mixins: [fandomBasicMixin, HFarmCorporateNavbarMixin],
  data() {
    return {
      backButtonWidth: '0px'
    };
  },
  mounted() {
    Vue.nextTick(() => {
      Vue.set(this, 'backButtonWidth', `${$("#back-button").outerWidth()}px`);
    });
  },
  methods: {
    isTouchDevice: Fandom.isTouchDevice,
    goBack() {
      history.back();
    },
    getLabel(item, items, index) {
      if (item.label) {
        return item.label;
      } else {
        let label = null;
        while (index > 0 && !label) {
          if (items[index - 1].label) {
            label = "$previousLabel";
          }
          index--;
        }
        return label;
      }
    }
  },
  computed: {
    isMobileNavigationActive() {
      return globalState.viewport.xs || globalState.viewport.sm || globalState.viewport.md;
    },
    leftPlaceholderStyle() {
      return {
        'width': this.backButtonWidth
      }
    },
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="d-flex flex-column flex-xl-row bg-gray-300" id="navbar-auxiliary" navbar-auxiliary-component>
    <div class="d-flex h-header">
      <div class="d-flex align-items-center py-3 px-4" id="back-button">
        <div class="cursor-pointer h4 mb-0 font-weight-normal d-flex align-items-center ml-2" @click="goBack">
          <i class="far fa-chevron-left mr-3"></i>
          {{ft('globals.back')}}
        </div>
      </div>
      <div v-if="!!content.items && content.items.length > 0" class="d-flex d-xl-none justify-content-end align-items-center flex-grow-1 navbar-custom-toggler" @click="$emit('mobile-menu', {items: content.items, theme: 'light'})">
        <div class="cursor-pointer py-3 px-4 d-flex justify-content-end align-items-center">
          <div class="font-weight-bold text-uppercase nav-item">Menu</div>
          <i class="far fa-ellipsis-h ml-2 fa-lg"></i>
        </div>
      </div>
    </div>
    <nav class="navbar position-static d-none navbar-expand-xl d-xl-flex justify-content-end flex-grow-1 p-0 h-100" id="auxiliary-nav">
      <div class="collapse navbar-collapse auxiliary-collapse h-100" :id="`navbar-auxiliary-${contentId}`">
        <div class="navbar-nav mx-xl-auto px-3 py-2 py-lg-0 h-100">
          <li
            :key="index"
            :ref="`subitem-wrapper-${index}`"
            v-for="(item, index) in getItems(content.items)"
            :class="{'active': isItemActive(item)}"
            class="nav-item px-2 px-xl-3 d-flex align-items-center"
          >  
            <a
              :target="getTarget(item.url)"
              :href="getItemHref(item)"
              class="font-weight-bold text-uppercase link-dark"
            >
              {{getItemTitle(item)}}
            </a>
            <div class="position-absolute submenu bg-white" :ref="`submenu-large-${index}`" v-if="!!item.items && item.items.length > 0">
              <div class="container-fluid" v-if="isTwoLevelsMenu(item)">
                <div class="row mx-auto" :class="item.items.length >= 5 ? `row-cols-${item.items.length}` : ''">
                  <div class="col px-4" v-for="(section, sectionIndex) in getItems(item.items)" :key="`section-${sectionIndex}-${index}`">
                    <div v-if="section.label" class="w-100 font-lg font-weight-bold border-bottom text-uppercase mb-3 d-inline-block py-1">{{section.label}}</div>
                    <div v-if="getLabel(section, getItems(item.items), sectionIndex) == '$previousLabel'" class="ml-n5 font-lg border-bottom mb-3 py-1 d-none d-xl-block">&nbsp;</div>
                    <a
                      class="font-weight-black link-dark text-uppercase h5 mb-3 d-block"
                      :href="getItemHref(section)"
                      :target="getTarget(section.url)"
                    >{{getItemTitle(section)}}</a>
                    <div
                      v-for="(subitem, subitemIndex) in getItems(section.items).filter(el => !!el.url).slice(0,12)"
                      :key="`subitem-${subitemIndex}-${sectionIndex}-${index}`"
                      class="mb-2"
                    >
                      <a class="link-dark" :href="getItemHref(subitem)" :target="getTarget(subitem.url)">
                        {{getItemTitle(subitem)}}
                      </a>
                    </div>
                    <a class="link-dark" v-if="getItems(section.items).filter(el => !!el.url).length > 12" :href="getItemHref(section)" :target="getTarget(section.url)">
                      ...{{ft('globals.find_more')}}
                    </a>
                  </div>
                </div>
              </div>
              <div class="container fluid" v-else>
                <div class="row mx-auto justify-content-center mb-n2">
                  <div v-for="n in [0,1,2,3,4,5].filter(el => el*5 < getItems(item.items).length)" :key="n" class="col px-4">
                    <a
                      class="link-dark d-block mb-2"
                      :href="getItemHref(subitem)"
                      :target="getTarget(subitem.url)"
                      v-for="(subitem, subitemIndex) in getItems(item.items).filter((el, idx) => idx < (n+1)*5 && idx >= n*5 && !!el.url)"
                      :key="`subitem-${subitemIndex}-${index}`"
                    >
                      {{getItemTitle(subitem)}}
                    </a>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex justify-content-center pt-5 border-top mt-5" v-if="item.button">
                <a :href="item.url.url" :target="getTarget(item.url)" class="btn btn-outline-dark">
                  {{ft('globals.discover')}} {{item.url.title}}
                </a>
              </div>
            </div>
          </li>
        </div>
      </div>
    </nav>
    <div class="d-none d-xl-block h-header light-theme" :style="leftPlaceholderStyle"></div>
  </div>
</template>

<style lang="scss" scoped>
[navbar-auxiliary-component] {
  &, .h-header {
    height: $auxiliary-navbar-height;
  }

  .font-lg {
    font-size: 14px;
  }

  .nav-item {
    font-size: .75rem !important;
    font-weight: 400;

    & > .submenu {
      left: 0;
      right: 0;
      top: 100%;
      padding: 0;
      height: 0;
      overflow: hidden; 

      a:hover {
        color: $black;
      }
    }

    &:hover > .submenu {
      transition: height .25s;
      height: auto;
      overflow: auto;
      padding: 3rem 0;
    }

    &:hover > a,
    &:active > a,
    &:focus > a,
    &.active > a,
    .link-dark:hover,
    .link-dark:active,
    .link-dark:focus,
    .link-dark.active {
      color: $gray-400;
    }

    &.selected {
      @include media-breakpoint-up(xl) {
        background-color: $gray-300;

        .nav-link {
          color: rgba(0, 0, 0, .7);
        }
      }
    }

    .subitem-column {
      max-width: 33.3333%;
    }
  }

  .border-bottom {
    border-color: #151515 !important;
  }
}
</style>
